import { useEffect, useState } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

// Desktop styles
const baseBoxStyle = {
    position: "fixed",
    bottom: 20,
    left: 20,
    background: "#f8f9fa",
    border: "1.5px solid #0fb7a4",
    padding: "1.2rem 1.2rem 1rem 1.2rem",
    borderRadius: 14,
    boxShadow: "0 6px 24px rgba(15, 183, 164, 0.13)",
    zIndex: 9999,
    maxWidth: 320,
};

const headerStyle = { display: "flex", flexDirection: "column", alignItems: "flex-start" };
const titleStyle = { fontSize: "1.1rem", color: "#222", fontWeight: 600, marginBottom: 2 };
const underlineStyle = { width: "100%", height: 1, background: "linear-gradient(90deg, #cacdcdff 60%, #e0e0e0 100%)", borderRadius: 2, marginBottom: 12 };
const listStyle = { listStyle: "none", padding: 0, margin: "0 0 0.7rem 0" };
const itemStyle = { display: "flex", alignItems: "center", background: "#e6f7f5", borderRadius: 6, marginBottom: 8, padding: "0.4rem 0.7rem", fontSize: "0.98rem", color: "#0fb7a4", fontWeight: 500, boxShadow: "0 1px 4px rgba(15, 183, 164, 0.07)" };
const pkgNameStyle = { flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };

const closeBtnStyle = {
    position: "absolute",
    top: 8,
    right: 8,
    background: "none",
    border: "none",
    color: "#888",
    cursor: "pointer",
    padding: 0,
    display: "flex",
    alignItems: "center",
    fontSize: 22,
    zIndex: 10001,
};

const FloatingCompareBox = ({ compareList, onCompareClick, onRemove, onClose }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [styles, setStyles] = useState(baseBoxStyle);

    useEffect(() => {
        const checkMobile = () => {
            const mobile = window.innerWidth <= 480;
            setIsMobile(mobile);

            setStyles({
                ...baseBoxStyle,
                bottom: mobile ? 60 : 20,
                left: mobile ? 10 : 20,
                right: mobile ? 10 : "auto",
                maxWidth: mobile ? "calc(100% - 20px)" : 320,
                padding: mobile ? "1rem" : "1.2rem 1.2rem 1rem 1.2rem",
                borderRadius: mobile ? 12 : 14,
            });
        };

        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    if (compareList.length === 0) return null;

    return (
        <div style={styles}>
            <button style={closeBtnStyle} title="Close" onClick={onClose}>
                <CloseOutlinedIcon fontSize={isMobile ? "small" : "medium"} />
            </button>

            <div style={headerStyle}>
                <h2
                    style={{
                        ...titleStyle,
                        fontSize: isMobile ? "1rem" : "1.1rem",
                    }}
                >
                    Selected Packages for Comparison
                </h2>
                <div style={underlineStyle}></div>
            </div>

            <ul style={listStyle}>
                {compareList.map((pkg, i) => (
                    <li
                        key={i}
                        style={{
                            ...itemStyle,
                            fontSize: isMobile ? "0.9rem" : "0.98rem",
                            padding: isMobile ? "0.35rem 0.6rem" : "0.4rem 0.7rem",
                        }}
                    >
                        <span style={pkgNameStyle}>{pkg?.service_name}</span>
                    </li>
                ))}
            </ul>

            <button
                className="rbdButton"
                onClick={onCompareClick}
                style={{
                    width: "100%",
                    padding: isMobile ? "0.6rem 0" : "0.7rem 0",
                    fontSize: isMobile ? "0.95rem" : "1rem",
                }}
            >
                <span className="btn-text">Compare Now</span>
            </button>
        </div>
    );
};

export default FloatingCompareBox;
